import { motion } from 'framer-motion';
import styles from './LoadingScreen.module.css';

export function LoadingScreen() {
  return (
    <div className={styles.root}>
      <motion.div
        className={styles.content}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        {/* Logo Mark */}
        <motion.div
          className={styles.logoMark}
          animate={{ rotate: [0, 360] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
        >
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path
              d="M14 2L24.392 8V20L14 26L3.608 20V8L14 2Z"
              fill="url(#gradient)"
              opacity="0.9"
            />
            <path
              d="M14 6L21.5 10.5V19.5L14 24L6.5 19.5V10.5L14 6Z"
              fill="none"
              stroke="white"
              strokeWidth="1.5"
              opacity="0.6"
            />
            <text x="10" y="17" fill="white" fontSize="8" fontWeight="bold" fontFamily="Inter">TX</text>
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="hsl(220, 70%, 60%)" />
                <stop offset="100%" stopColor="hsl(168, 65%, 50%)" />
              </linearGradient>
            </defs>
          </svg>
        </motion.div>

        <motion.div
          className={styles.name}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          ISO<span>TIX</span>360
        </motion.div>

        <motion.div
          className={styles.tagline}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Sistema de Gestión de Calidad
        </motion.div>

        {/* Loading dots */}
        <div className={styles.dots}>
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className={styles.dot}
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.2 }}
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
}
